import {Button, Dialog, DialogContent} from "@mui/material";
import styles from 'assets/css/notAllowedModal.module.css';
import {styled} from "@mui/material/styles";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Grid from "@mui/material/Grid";
import React from "react";
import {detectPathUrl} from "helpers/detectPathUrl";
import {useNavigate} from "react-router-dom";

const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: 100%;
    min-height: 400px;
    //height: 320px;
    max-width: 100%;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    //padding: 24px 16px 34px;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }

  & .MuiDialogContent-root {
    padding: 0
  }`;

export const NotAllowedScanModal = (props) => {
    const {open, setOpen} = props
    const navigate = useNavigate()
    const handleClose = () => {
        setOpen(false)
    }
    const handleClick = () => {
      setOpen(false)
        navigate(detectPathUrl('app/home'))
    }
    const checkOnCloseClick = (event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
    };
    return (
        <CustomizedDialog
            open={open}
            onClose={checkOnCloseClick}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <div>
                <DialogContent>
                    <Grid container>
                        <p className={styles.errorTitle}>عدم دسترسی به اسکن کردن</p>
                        <ErrorOutlineIcon className={styles.iconError}/>

                        <p className={styles.errorText}> هیچ پزشکی شما را به عنوان دستیار ثبت نکرده؛ لطفا از پزشک خود بخواهید شما را به عنوان دستیار خود ثبت کند.</p>
                        <p className={styles.errorText2}>برای این کار کافی است پزشک در قسمت دستیارانش شما را به عنوان دستیار اضافه کند.</p>
                        <Button onClick={handleClick} className={`${styles.okButton} `}>
                            متوجه شدم </Button>

                    </Grid>
                </DialogContent>
            </div>
        </CustomizedDialog>
    )
}